import React from "react";
import Storage from "../../services/storage.service";
import Confirmation from "./onboarding-confirmation.component";
import ConfirmationTopup from "../../views/topUp/top-up-confirmation";
import checkModule from "../shared/checkModule";
import ConfirmationTopupTAP from "../topUp/top-up-tap-confirmation";
import CONSTANTS from "../../services/constants.service";
import ConfirmationBillPaymentTAP from "../bill-payment/bill-payment-tap-confirmation";
import Helpers from "../../helpers/shared.helper";
import ConfirmationBillPaymentTAPMulti from "../bill-payment/bill-payment-tap-multi-confirmation";
const ConfirmationAll = (props) => {
	const { isPaymentKsa } = checkModule;
	if (Storage.get("choose_topup_category", true)) {
		if (Storage.get("selected_payment_method", true) === CONSTANTS.PAYMENT_TAP_CARD && isPaymentKsa) {
			return <ConfirmationTopupTAP />
		} else {
			return <ConfirmationTopup />
		}
	} else if(Storage.get("choose_bill_payment", true) || Storage.get("choose_sim_deactivation", true)) {
		if(Storage.get("secure-link-id", true)) {
			return <ConfirmationBillPaymentTAPMulti history={props.history} sim_deactivation={Storage.get("choose_sim_deactivation", true) ? true : false}/>;
		} else {
			return <ConfirmationBillPaymentTAP history={props.history} sim_deactivation={Storage.get("choose_sim_deactivation", true) ? true : false}/>;
		}
	} else {
		const capturing = Helpers.getStorageBooleanValue(CONSTANTS.ENABLE_PAYMENT_CAPTURE);
		return <Confirmation capturing={capturing}/>
	}
}

export default ConfirmationAll;